import { PROJECT_NAME } from "@/firebase/init";
import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import mixin from "@/mixin";
import { db } from "@/main";
@Component
export default class Main extends mixins(mixin) {
  darkMode = true;
  UID = "";
  type = "";
  subType = "";
  userData = { profile_info: { image: "" } };
  items: any[] = [];
  projectName = "";
  color = "";
  drawer = null;
  drawerRight = null;
  item = null;
  srcImageDefault =
    "https://www.fancyhands.com/images/default-avatar-250x250.png";

  adminListener: any = null;
  userListener: any = null;

  async mounted() {
    this.projectName = PROJECT_NAME;
    this.color = "#FF1736";
    this.loadUserData();
  }

  loadUserData() {
    this.UID = this.$store.state.user.uid;
    this.type = this.$store.state.user.type;
    this.subType = this.$store.state.user.subType;
    this.userData = this.$store.state.user.data;
    if (this.userData !== null && this.userData !== undefined) {
      if (
        this.userData.profile_info !== null &&
        this.userData.profile_info !== undefined
      ) {
        if (
          this.userData.profile_info.image == undefined &&
          this.userData.profile_info.image == null
        ) {
          this.userData.profile_info.image = "";
        }
      }
    }
    if (!this.UID) {
      this.items = [];
      return;
    }
    if (this.type === "admin") {
      if (this.adminListener) {
        this.adminListener();
      }
      this.adminListener = db
        .collection("admins")
        .doc(this.UID)
        .onSnapshot(doc => {
          this.items = [];
          for (const permission in doc.data()?.permissions) {
            if (permission !== "write") {
              this.items.push(doc.data()?.permissions[permission]);
            }
          }
          this.items.sort((a, b) => {
            return a.position - b.position;
          });
        });
    } else if (this.type === "user") {
      if (this.userListener) {
        this.userListener();
      }
      this.userListener = db
        .collection("client_employees")
        .doc(this.UID)
        .onSnapshot(doc => {
          this.items = [];
          for (const permission in doc.data()?.permissions) {
            if (permission !== "write") {
              this.items.push(doc.data()?.permissions[permission]);
            }
          }
          this.items.sort((a, b) => {
            return a.position - b.position;
          });
        });
    }
  }

  @Watch("$store.state.user.uid")
  onUserUidChange() {
    this.loadUserData();
  }

  @Watch("$route")
  onRouteChange() {
    if (this.$store.state.user.uid && (!this.items || this.items.length === 0)) {
      this.loadUserData();
    }
  }
  @Watch("darkMode")
  onDarkModeChange(val) {
    this.$vuetify.theme.dark = val;
    console.log(val);
  }
}
